import React, { useEffect, useState } from "react";
import "./style.scss";
import AreaChart from "../AreaChart";
import Select from "react-select";
import customStyles from "../../../../customStyles";
import { useSelector } from "react-redux";
import { getAffiliateStats } from "../../../../utils/apis/payments";
import { FormatUSD } from "../../../../utils/helpers/string";
import { DatePicker, Empty } from "antd";
import dayjs from "dayjs";
import CustomRangeSelector from "../../../../reusableComponents/RangeSelector/CustomRangeSelector";
const { RangePicker } = DatePicker;

function ClickStatistics() {
  const { idToken } = useSelector((state) => state.auth);
  const [codeList, setCodeList] = useState({});
  const [dateRange, setDateRange] = useState(null);
  const pushLeadData = codeList?.click_stats || [];
  const allClicks = codeList?.click_stats?.reduce(
    (totalClicks, currentItem) => totalClicks + currentItem.clicks,
    0
  );

  const fetchAffiliate = async () => {
    try {
      const dateParams = {};
      if (dateRange && dateRange.length === 2) {
        dateParams.start_date = dateRange[0].format("YYYY-MM-DD");
        dateParams.end_date = dateRange[1].format("YYYY-MM-DD");
      }

      const response = await getAffiliateStats(idToken, dateParams);
      setCodeList(response?.data || []);
    } catch (error) {}
  };
  useEffect(() => {
    fetchAffiliate();
  }, [dateRange]);

  const options = [
    { value: "monthly", label: "Monthly" },
    { value: "weekly", label: "Weekly" },
    { value: "daily", label: "Daily" },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  return (
    <div className="click-stats box">
      <div className="click-stats-header">
        <h2 className="component-heading">Clicks Statistics</h2>
        <div className="date-filters">
          <CustomRangeSelector
            dateRange={dateRange}
            handleDateChange={(dates) => setDateRange(dates)}
          />
          {/* <Select
          value={selectedOption}
          isSearchable={false}
          onChange={handleChange}
          options={options}
          styles={customStyles}
        /> */}
        </div>
      </div>

      <div className="cs-chart">
        {pushLeadData.length === 0 ? (
          <Empty description="No Data" />
        ) : (
          <AreaChart codeList={pushLeadData} />
        )}
      </div>

      <div className="csinfobox-wrapper">
        <CsInfoBox title="Clicks" value={allClicks} />
        <CsInfoBox title="Pushed Leads" value={codeList?.pushed_leads} />
        <CsInfoBox
          title="Commissions"
          value={FormatUSD(codeList?.commission_amount)}
        />
        <CsInfoBox title="Conversions " value={codeList?.conversions} />
      </div>
    </div>
  );
}

export default ClickStatistics;

const CsInfoBox = ({ title, value }) => {
  return (
    <div className="csinfobox">
      <p>{title}</p>
      <span>{value}</span>
    </div>
  );
};
